<template>
  <div class="food-manage">
    <div class="schedule-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="上课时间" class="fn-left">
            <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>
          <el-form-item label="选择校区" class="fn-left">
            <Select key="6" :selected.sync="listQuery.shopId" clearable :data="shopList" placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.gradeId" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subjectId" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="授课老师" class="fn-left">
            <el-input v-model="listQuery.teacherName" placeholder="请输入查询内容" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetScheduleList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddSchedule()">创建排课</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnUpdateSchedule()">批量配置课程内容</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="danger" @click="fnDelete()">批量删除</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey+'maintable'" :data="lists" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="校区" prop="shop_name" align="center" />
        <el-table-column label="上课日期" prop="class_date" align="center" />
        <el-table-column label="上课时间" prop="class_hours" align="center" />
        <el-table-column label="科目" prop="subject_name" align="center" />
        <el-table-column label="授课年级" prop="grade_names" align="center" />
        <el-table-column label="教室" prop="space_name" align="center" />
        <el-table-column label="授课老师" prop="lecturer_name" align="center" />
        <el-table-column label="课程名称" prop="content_detail" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <div>
              <el-button type="text" @click="fnToClassScheduleSetting(row.id)">编辑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="20" @current-change="fnGetScheduleList" />
    </div>
    <el-dialog title="创建&编辑" :visible.sync="dialogFormVisible" class="class-detail-dialog">
      <el-form ref="postForm" :model="postForm" :rules="rules" label-position="labelPosition" class="filter-input">
        <el-form-item label="授课科目" label-width="120px" prop="subjectId">
          <Select key="15" :selected.sync="postForm.subjectId" :data="subjectLists" clearable placeholder="请选择授课科目" @updateSelect="fnUpdateSubject" />
        </el-form-item>
        <el-form-item label="课程" label-width="120px" prop="subjectId">
          <Select key="333" :selected.sync="postForm.contentDetailId" :data="classLists" clearable placeholder="请选择课程" @updateSelect="() => { postForm.teacherId = '' }" />
        </el-form-item>
        <el-form-item label="授课年级" label-width="120px" prop="gradeId">
          <el-checkbox-group v-model="postForm.gradeId">
            <el-checkbox v-for="(item,index) in gradeLists" :key="'grade' + index" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="授课校区" label-width="120px" prop="shopId">
          <Select key="16" :selected.sync="postForm.shopId" :data="shopList" placeholder="请选择" @updateSelect="() => { postForm.spaceId = '' }" />
        </el-form-item>
        <el-form-item label="授课教室" label-width="120px" prop="spaceId">
          <Select key="7" :selected.sync="postForm.spaceId" :data="spaceList" placeholder="请选择" />
        </el-form-item>
        <el-form-item label="授课老师" label-width="120px" prop="teacherId">
          <el-select v-model="postForm.teacherId" filterable placeholder="请选择">
            <el-option
              v-for="item in teacherList"
              :key="item.uid + 'teacher'"
              :label="item.nickname"
              :value="item.uid"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="postForm.id === ''" label="排课方式" label-width="120px">
          <el-radio-group v-model="addType">
            <el-radio :label="1">循环</el-radio>
            <el-radio :label="2">单次</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="addType == 2" label="上课日期" label-width="120px">
          <el-date-picker
            v-model="postForm.classDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item v-show="addType == 1" label="上课日期" label-width="120px">
          <el-date-picker v-model="formDate" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item v-if="addType == 1" label="上课周期" label-width="120px">
          <el-checkbox-group v-model="weekList">
            <el-checkbox v-for="(item,index) in weekMap" :key="'week' + index" :label="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="开始时间" label-width="120px" prop="beginHour">
          <el-time-picker
            v-model="postForm.beginHour"
            placeholder="开始时间"
            value-format="HH:mm"
            :picker-options="{
              startTime: '',
              format: 'HH:mm',
              maxTime: postForm.endHour
            }"
          />
        </el-form-item>
        <el-form-item label="结束时间" label-width="120px" prop="endHour">
          <el-time-picker
            v-model="postForm.endHour"
            placeholder="结束时间"
            value-format="HH:mm"
            :picker-options="{
              format: 'HH:mm',
              minTime: postForm.beginHour
            }"
          />
        </el-form-item>
        <el-button v-if="addType == 1" type="primary" @click="fnGetClassDateList()">生成排课日期</el-button>
        <el-button v-if="addType == 2" type="primary" :loading="bCreateLoading" @click="fnCreateScheduleSubmit()">确定</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      title="课程内容"
      :visible.sync="bindCourseVisible"
      class="schedule-course-details-dialog"
      width="700px"
    >
      <div class="dialog-content">
        <div>课程名称: {{ currentCourse.title }}</div>
        <div>授课科目: {{ currentCourse.subject_name }}</div>
        <div>授课年级: {{ currentCourse.grade_names }}</div>
        <div>课程介绍: {{ currentCourse.content }}</div>
      </div>
      <el-button style="margin-top: 20px;" type="primary" @click="fnConfirmUpdateSchedule()">确定配置</el-button>
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'
import { validateRequire } from '@/utils/validate'

const defaultPostForm = {
  subjectId: '',
  gradeId: [],
  shopId: '',
  spaceId: '',
  classDate: '',
  beginHour: '',
  endHour: '',
  teacherId: '',
  id: '',
  contentDetailId: ''
}

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    Select
  },
  data() {
    return {
      rules: {
        endHour: [{ validator: validateRequire, trigger: 'manual', message: '结束上课时间' }],
        beginHour: [{ validator: validateRequire, trigger: 'manual', message: '开始上课时间' }],
        teacherId: [{ validator: validateRequire, trigger: 'manual', message: '授课老师' }],
        spaceId: [{ validator: validateRequire, trigger: 'manual', message: '授课教室' }],
        subjectId: [{ validator: validateRequire, trigger: 'manual', message: '授课科目' }],
        shopId: [{ validator: validateRequire, trigger: 'manual', message: '授课校区' }],
        gradeId: [{ validator: (rule, value, callback) => {
          if (value.length === 0) {
            this.$message({ message: rule.message + '为必传项', type: 'error' })
          } else {
            callback()
          }
        }, trigger: 'manual', message: '授课年级' }]
      },
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        shopId: '',
        subjectId: '',
        gradeId: '',
        beginDate: '',
        endDate: '',
        teacherName: ''
      },
      date: [Tool.formatTime(new Date(), 'date'), Tool.formatTime(new Date(new Date().valueOf() + 86400 * 1000 * 30), 'date')],
      formDate: [],
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.SUBJECT_MAP,
      weekMap: commondata.WEEK_MAP,
      total: 0,
      postForm: Object.assign({}, defaultPostForm),
      dialogFormVisible: false,
      bCreateLoading: false,
      shopList: [],
      multipleSelection: [],
      bindCourseVisible: false,
      currentCourse: {},
      spaceList: [],
      teacherList: [],
      addType: 1,
      weekList: [],
      classLists: []
    }
  },
  watch: {
    'postForm.shopId': {
      handler: function(newVal) {
        if (newVal) {
          this.fnGetSpaceListByShopId()
        }
      }
    },
    'postForm.subjectId': {
      handler: function(newVal) {
        if (newVal) {
          this.fnGetTeacherListBySubject()
        }
      }
    },
    addType: {
      handler: function() {
        this.postForm.classDate = ''
      }
    }
  },
  created() {
    this.fnGetScheduleList()
    this.getMyShopList()
  },
  methods: {
    fnGetClassDateList: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          if (this.formDate.length === 0) {
            this.$message({
              message: '请选择上课日期',
              type: 'error'
            })
            return false
          }
          if (this.weekList.length === 0) {
            this.$message({
              message: '请选择上课周期',
              type: 'error'
            })
            return false
          }
          this.$http.getClassDateList({ week: this.weekList.join(','), beginDate: this.formDate[0], endDate: this.formDate[1] }).then(res => {
            const classDate = res.data
            this.$confirm(`${classDate.join(',')}`, '上课日期', {
              confirmButtonText: '确定排课',
              cancelButtonText: '修改排课日期',
              type: 'success'
            }).then(() => {
              const form = Object.assign({}, this.postForm)
              form.gradeId = form.gradeId.join(',')
              form.classDate = classDate.join(',')
              this.$http.createSchedule(form).then(res => {
                if (res.code === 200) {
                  this.$message({
                    message: '操作成功！',
                    type: 'success'
                  })
                  this.dialogFormVisible = false
                  this.fnGetScheduleList()
                }
              })
            })
          })
        }
      })
    },
    fnGetTeacherListBySubject: function() {
      this.$http.getTeacherListBySubject({ subjectId: this.postForm.subjectId }).then(res => {
        this.teacherList = res.data
      })
    },
    fnGetSpaceListByShopId: function() {
      this.$http.getSpaceListByShopId({ shopId: this.postForm.shopId }).then(res => {
        this.spaceList = res.data
      })
    },
    fnConfirmUpdateSchedule: function() {
      const ids = this.multipleSelection.map((e) => { return e.id }).join(',')
      this.$http.updateSchedule({ id: ids, contentDetailId: this.currentCourse.id }).then(res => {
        this.$message({
          message: '操作成功！',
          type: 'success'
        })
        this.bindCourseVisible = false
        this.fnGetScheduleList()
      })
    },
    fnUpdateSchedule: function() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择课表',
          type: 'error'
        })
        return false
      }
      this.$prompt('请输入课程内容ID', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /./,
        inputErrorMessage: '课程内容ID不能为空'
      }).then(({ value }) => {
        this.$http.getClassContentInfo({ id: value }).then(res => {
          if (res.data && res.data.id) {
            this.currentCourse = res.data
            this.bindCourseVisible = true
          } else {
            this.$message({
              message: '不存在该课程',
              type: 'warning'
            })
          }
        })
      })
    },
    handleSelectionChange: function(val) {
      this.multipleSelection = val
    },
    getMyShopList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
    },
    fnCreateScheduleSubmit: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          if (!this.postForm.classDate) {
            this.$message({
              message: '上课日期不能为空',
              type: 'error'
            })
            return false
          }
          const form = Object.assign({}, this.postForm)
          form.gradeId = form.gradeId.join(',')
          this.bCreateLoading = true
          if (form.id) {
            this.$http.updateSchedule(form).then(res => {
              this.bCreateLoading = false
              if (res.code === 200) {
                this.$message({
                  message: '操作成功！',
                  type: 'success'
                })
                this.dialogFormVisible = false
                this.fnGetScheduleList()
              }
            })
          } else {
            this.$http.createSchedule(form).then(res => {
              this.bCreateLoading = false
              if (res.code === 200) {
                this.$message({
                  message: '操作成功！',
                  type: 'success'
                })
                this.dialogFormVisible = false
                this.fnGetScheduleList()
              }
            })
          }
        }
      })
    },
    fnAddSchedule: function() {
      this.postForm = Object.assign({}, defaultPostForm)
      this.dialogFormVisible = true
    },
    fnGetScheduleList: function() {
      if (this.date != null) {
        this.listQuery.beginDate = this.date[0]
        this.listQuery.endDate = this.date[1]
      } else {
        this.listQuery.beginDate = ''
        this.listQuery.endDate = ''
        this.date = []
      }
      this.$http.getScheduleList(this.listQuery).then(res => {
        this.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnUpdateSubject(val) {
      console.log(val)
      this.postForm.teacherId = ''
      this.postForm.contentDetailId = ''
      this.fnGetClassNameLists(val)
    },
    fnGetClassNameLists(val) {
      this.$http.getClassNameBySubject({ subjectId: val }).then(res => {
        res.data.forEach((ele) => {
          ele.name = ele.title
        })
        this.classLists = res.data
      })
    },
    fnToClassScheduleSetting(id) {
      this.addType = 2
      this.$http.getClassScheduleInfo({ id }).then(res => {
        const { data } = res
        this.$nextTick(() => {
          this.postForm = {
            subjectId: parseInt(data.subject_id),
            gradeId: data.grade_ids.split(','),
            shopId: data.shop_id,
            spaceId: data.space_id,
            classDate: data.class_date,
            beginHour: data.class_hours.split('~')[0],
            endHour: data.class_hours.split('~')[1],
            teacherId: data.lecturer_id,
            id: data.id,
            contentDetailId: data.content_detail_id
          }
          if (this.postForm.subjectId) {
            this.fnGetClassNameLists(this.postForm.subjectId)
          }
          this.dialogFormVisible = true
        })
      })
    },
    fnDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择课表',
          type: 'error'
        })
        return false
      }
      this.$confirm('删除课表将同时删除签到记录及老师填写的课程反馈，确认删除么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        const ids = this.multipleSelection.map((e) => { return e.id }).join(',')
        this.$http.updateSchedule({ id: ids, isDelete: 1 }).then(res => {
          this.$message({
            message: '操作成功！',
            type: 'success'
          })
          this.fnGetScheduleList()
        })
      })
    }
  }
}
</script>
<style lang="scss">
  .class-detail-dialog .el-dialog__body {
    height: 700px;
    padding: 20px 30px;
    overflow: auto;
}
.schedule-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
